export const APPLICATION = {
  AI_MODE_application_wasDetail: 'AI_MODE_application_wasDetail',

  APPLICATION_WAS_DETAIL_DASHBOARD_SETTING_LIST: 'APPLICATION_WAS_DETAIL_DASHBOARD_SETTING_LIST',
  APPLICATION_WEB_SERVER_DETAIL_DASHBOARD_SETTING_LIST:
    'APPLICATION_WEB_SERVER_DETAIL_DASHBOARD_SETTING_LIST',

  GRIDSETTINGS_application_was_wasList: 'GRIDSETTINGS_application_was_wasList',

  GRIDCOLUMNS_application_wasDetail_active_activeTxnList:
    'GRIDCOLUMNS_application_wasDetail_active_activeTxnList',
  GRIDCOLUMNS_application_wasDetail_config_configList:
    'GRIDCOLUMNS_application_wasDetail_config_configList',
  GRIDCOLUMNS_application_wasDetail_dataSource_connectionList:
    'GRIDCOLUMNS_application_wasDetail_dataSource_connectionList',
  GRIDCOLUMNS_application_wasDetail_heapDump_heapDumpList:
    'GRIDCOLUMNS_application_wasDetail_heapDump_heapDumpList',
  GRIDCOLUMNS_application_wasDetail_libraries_libraryList:
    'GRIDCOLUMNS_application_wasDetail_libraries_libraryList',
  GRIDCOLUMNS_application_wasDetail_loadedClassList_loadedClass:
    'GRIDCOLUMNS_application_wasDetail_loadedClassList_loadedClass',
  GRIDCOLUMNS_application_wasDetail_loadedClassList_loadedClassList:
    'GRIDCOLUMNS_application_wasDetail_loadedClassList_loadedClassList',
  GRIDCOLUMNS_application_wasDetail_loadedClassChangeWindow_list:
    'GRIDCOLUMNS_application_wasDetail_loadedClassChangeWindow_list',
  GRIDCOLUMNS_application_wasDetail_threadDump_threadDumpList:
    'GRIDCOLUMNS_application_wasDetail_threadDump_threadDumpList',
  GRIDCOLUMNS_application_wasDetail_transaction_transactionList:
    'GRIDCOLUMNS_application_wasDetail_transaction_transactionList',

  GRIDCOLUMNS_application_transactionInfoDetail_activeHistoryList:
    'GRIDCOLUMNS_application_transactionInfoDetail_activeHistoryList',

  GRIDCOLUMNS_application_transactionDetail_otel_otelList:
    'GRIDCOLUMNS_application_transactionDetail_otel_otelList',
  GRIDCOLUMNS_application_transactionDetail_otelDetail_logList_logList:
    'GRIDCOLUMNS_application_transactionDetail_otelDetail_logList_logList',

  GRIDCOLUMNS_application_transactionDetail_etoe_etoeList:
    'GRIDCOLUMNS_application_transactionDetail_etoe_etoeList',
  GRIDCOLUMNS_application_transactionDetail_etoeDetail_activeHistory_activeList:
    'GRIDCOLUMNS_application_transactionDetail_etoeDetail_activeHistory_activeList',
  GRIDCOLUMNS_application_transactionDetail_etoelDetail_callTree_CallTreeListSummary:
    'GRIDCOLUMNS_application_transactionDetail_etoelDetail_callTree_CallTreeListSummary',
  GRIDCOLUMNS_application_transactionDetail_etoelDetail_callTree_CallTreeListDetail:
    'GRIDCOLUMNS_application_transactionDetail_etoelDetail_callTree_CallTreeListDetail_v2',
  GRIDCOLUMNS_application_transactionDetail_etoeDetail_sqlText_sqlList:
    'GRIDCOLUMNS_application_transactionDetail_etoeDetail_sqlText_sqlList',
  GRIDCOLUMNS_application_transactionDetail_etoeDetail_sqlStatistics:
    'GRIDCOLUMNS_application_transactionDetail_etoeDetail_sqlStatistics',
  GRIDCOLUMNS_application_transactionDetail_etoeDetail_webActiveHistory_activeList:
    'GRIDCOLUMNS_application_transactionDetail_etoeDetail_webActiveHistory_activeList',

  GRIDCOLUMNS_application_traces_tracesList: 'GRIDCOLUMNS_application_traces_tracesList',

  GRIDCOLUMNS_application_activeTransactionDetail_activeTxnList:
    'GRIDCOLUMNS_application_activeTransactionDetail_activeTxnList',

  GRIDSETTINGS_application_webServer_webServerList:
    'GRIDSETTINGS_application_webServer_webServerList',
  GRIDSETTINGS_application_webServerDetail_activeWebTransactions_activeWebTransactionsList:
    'GRIDSETTINGS_application_webServerDetail_activeWebTransactions_activeWebTransactionsList',
  GRIDSETTINGS_application_webServerDetail_webTransactions_webTransactionsList:
    'GRIDSETTINGS_application_webServerDetail_webTransactions_webTransactionsList',
  GRIDSETTINGS_application_webServerDetail_upstream_upstreamList:
    'GRIDSETTINGS_application_webServerDetail_upstream_upstreamList',
  GRIDSETTINGS_application_webServerDetail_worker_workerList:
    'GRIDSETTINGS_application_webServerDetail_worker_workerList',
  GRIDSETTINGS_application_webServerDetail_cache_cacheList:
    'GRIDSETTINGS_application_webServerDetail_cache_cacheList',
  GRIDSETTINGS_application_webServerDetail_config_configList:
    'GRIDSETTINGS_application_webServerDetail_config_configList',

  GRIDCOLUMNS_application_webApplication_applicationList:
    'GRIDCOLUMNS_application_webApplication_applicationList',
  GRIDCOLUMNS_application_webApplication_applicationDetail_pageAnalysis_analysisList:
    'GRIDCOLUMNS_application_webApplication_applicationDetail_pageAnalysis_analysisList',
  GRIDCOLUMNS_application_webApplication_pageDetail_resourceTimelineList:
    'GRIDCOLUMNS_application_webApplication_pageDetail_resourceTimelineList',
  GRIDCOLUMNS_application_webApplication_pageDetail_ajaxRequestHistoryList:
    'GRIDCOLUMNS_application_webApplication_pageDetail_ajaxRequestHistoryList',
  GRIDCOLUMNS_application_webApplication_pageDetail_ajaxRequestHistoryListDetail_ajaxCallHistoryList:
    'GRIDCOLUMNS_application_webApplication_pageDetail_ajaxRequestHistoryListDetail_ajaxCallHistoryList',
  GRIDCOLUMNS_application_rum_userMonitoring_userSessionLogList:
    'GRIDCOLUMNS_application_rum_userMonitoring_userSessionLogList',
  GRIDCOLUMNS_application_rum_userMonitoring_sessionAnalysisDetail_sessionList:
    'GRIDCOLUMNS_application_rum_userMonitoring_sessionAnalysisDetail_sessionList',
  GRIDCOLUMNS_application_rum_browserErrorTracking_browserErrorLogList:
    'GRIDCOLUMNS_application_rum_browserErrorTracking_browserErrorLogList',

  GRIDCOLUMNS_application_url_monitoring_urlList: 'GRIDCOLUMNS_application_url_monitoring_urlList',
  GRIDCOLUMNS_application_url_monitoring_urlDetail_urlResponseList:
    'GRIDCOLUMNS_application_url_monitoring_urlDetail_urlResponseList',

  // Application > PA
  GRIDCOLUMNS_application_pa_dailyReport_topGrid: 'GRIDCOLUMNS_application_pa_dailyReport_topGrid',
  GRIDCOLUMNS_application_pa_dailyReport_bottomGrid:
    'GRIDCOLUMNS_application_pa_dailyReport_bottomGrid',

  FILTER_application_was: 'FILTER_application_was',
  FILTER_application_webServer: 'FILTER_application_webServer',
  FILTER_application_rum_browserErrorTracking: 'FILTER_application_rum_browserErrorTracking',
  FILTER_application_transaction: 'FILTER_application_transaction',
  FILTER_application_pagePerformanceMonitoring: 'FILTER_application_pagePerformanceMonitoring',
  FILTER_application_pagePerformanceMonitoringDetail_pageList:
    'FILTER_application_pagePerformanceMonitoringDetail_pageList',
  FILTER_application_webApplication: 'FILTER_application_webApplication',
  FILTER_application_rum_userMonitoring: 'FILTER_application_rum_userMonitoring',
  FILTER_application_rum_userMonitoring_sessionAnalysisDetail_sessionList:
    'FILTER_application_rum_userMonitoring_sessionAnalysisDetail_sessionList',
  FILTERSEARCH_application_was_wasList: 'FILTERSEARCH_application_was_wasList',
  FILTERSEARCH_application_webServer_webServerList:
    'FILTERSEARCH_application_webServer_webServerList',
  FILTERSEARCH_application_rum_webApplication_applicationList:
    'FILTERSEARCH_application_rum_webApplication_applicationList',
  FILTERSEARCH_application_rum_webApplication_applicationListDetail_pageAnalysisList:
    'FILTERSEARCH_application_rum_webApplication_applicationListDetail_pageAnalysisList',
  FILTERSEARCH_application_rum_webApplicationDetail_resourceTimelineList:
    'FILTERSEARCH_application_rum_webApplicationDetail_resourceTimelineList',
  FILTERSEARCH_application_rum_webApplicationDetail_ajaxRequestHistoryList:
    'FILTERSEARCH_application_rum_webApplicationDetail_ajaxRequestHistoryList',
  FILTERSEARCH_application_rum_webApplicationDetail_ajaxRequestHistoryListDetail_ajaxCallHistoryList:
    'FILTERSEARCH_application_rum_webApplicationDetail_ajaxRequestHistoryListDetail_ajaxCallHistoryList',
  FILTERSEARCH_application_rum_browserErrorTracking_browserErrorLogList:
    'FILTERSEARCH_application_browserErrorTracking_browserErrorLogList',
  FILTERSEARCH_application_rum_userMonitoring_userSessionLogList:
    'FILTERSEARCH_application_rum_userMonitoring_userSessionLogList',
  FILTER_application_url_monitoring: 'FILTER_application_url_monitoring',
  FILTER_application_url_monitoring_urlList: 'FILTER_application_url_monitoring_urlList',
  FILTER_application_url_monitoring_detailList: 'FILTER_application_url_monitoring_urlDetailList',
  FILTER_application_url_monitoring_config_urlList:
    'FILTER_application_url_monitoring_config_urlList',

  FILTERSEARCH_application_wasDetail_active_activeTxnList:
    'FILTERSEARCH_application_wasDetail_active_activeTxnList',
  FILTERSEARCH_application_wasDetail_config_configList:
    'FILTERSEARCH_application_wasDetail_config_configList',
  FILTERSEARCH_application_wasDetail_dataSource_connectionList:
    'FILTERSEARCH_application_wasDetail_dataSource_connectionList',
  FILTERSEARCH_application_wasDetail_heapDump_heapDumpList:
    'FILTERSEARCH_application_wasDetail_heapDump_heapDumpList',
  FILTERSEARCH_application_wasDetail_libraries_libraryList:
    'FILTERSEARCH_application_wasDetail_libraries_libraryList',
  FILTERSEARCH_application_wasDetail_loadedClassList_loadedClassList:
    'FILTERSEARCH_application_wasDetail_loadedClassList_loadedClassList',
  FILTERSEARCH_application_wasDetail_loadedClassChangeWindow_list:
    'FILTERSEARCH_application_wasDetail_loadedClassChangeWindow_list',
  FILTERSEARCH_application_wasDetail_threadDump_threadDumpList:
    'FILTERSEARCH_application_wasDetail_threadDump_threadDumpList',
  FILTERSEARCH_application_wasDetail_transaction_transactionList:
    'FILTERSEARCH_application_wasDetail_transaction_transactionList',
  FILTERSEARCH_application_heapDumpPathWindow_heapDumpPathList:
    'FILTERSEARCH_application_heapDumpPathWindow_heapDumpPathList',

  // 컬럼 설정(GRIDCOLUMNS_application_xviewPopup_*)과 같은 그리드 짝이라 접미사·철자를 맞춘다.
  FILTERSEARCH_application_xviewPopup_list: 'FILTERSEARCH_application_xviewPopup_list',
  FILTERSEARCH_application_xviewPopup_stats: 'FILTERSEARCH_application_xviewPopup_stats',
  FILTERSEARCH_application_xviewPopup_excOtherTypes:
    'FILTERSEARCH_application_xviewPopup_excOtherTypes',
  FILTERSEARCH_application_xviewPopup_excAffectedTxns:
    'FILTERSEARCH_application_xviewPopup_excAffectedTxns',

  LASTDUMPPATH_application_heapDumpPathWindow: 'LASTDUMPPATH_application_heapDumpPathWindow',

  FILTERSERACH_application_transactionInfoDetail_activeHistoryList:
    'FILTERSERACH_application_transactionInfoDetail_activeHistoryList',

  FILTERSEARCH_application_webServerDetail_activeWebTransactions_activeWebTransactionsList:
    'FILTERSEARCH_application_webServerDetail_activeWebTransactions_activeWebTransactionsList',
  FILTERSEARCH_application_webServerDetail_webTransactions_webTransactionsList:
    'FILTERSEARCH_application_webServerDetail_webTransactions_webTransactionsList',
  FILTERSEARCH_application_webServerDetail_upstream_upstreamList:
    'FILTERSEARCH_application_webServerDetail_upstream_upstreamList',
  FILTERSEARCH_application_webServerDetail_worker_workerList:
    'FILTERSEARCH_application_webServerDetail_worker_workerList',
  FILTERSEARCH_application_webServerDetail_cache_cacheList:
    'FILTERSEARCH_application_webServerDetail_cache_cacheList',
  FILTERSEARCH_application_webServerDetail_config_configList:
    'FILTERSEARCH_application_webServerDetail_config_configList',

  FILTERSEARCH_application_transactionDetail_etoe_etoeList:
    'FILTERSEARCH_application_transactionDetail_etoe_etoeList',
  FILTERSEARCH_application_transactionDetail_etoeDetail_activeHistory_activeList:
    'FILTERSEARCH_application_transactionDetail_etoeDetail_activeHistory_activeList',
  FILTERSEARCH_application_transactionDetail_etoelDetail_callTree_CallTreeListSummary:
    'FILTERSEARCH_application_transactionDetail_etoelDetail_callTree_CallTreeListSummary',
  FILTERSEARCH_application_transactionDetail_etoelDetail_callTree_CallTreeListDetail:
    'FILTERSEARCH_application_transactionDetail_etoelDetail_callTree_CallTreeListDetail',
  FILTERSEARCH_application_transactionDetail_etoeDetail_sqlText_sqlList:
    'FILTERSEARCH_application_transactionDetail_etoeDetail_sqlText_sqlList',
  FILTERSEARCH_application_transactionDetail_etoeDetail_sqlStatistics:
    'FILTERSEARCH_application_transactionDetail_etoeDetail_sqlStatistics',
  FILTERSEARCH_application_transactionDetail_etoeDetail_webActiveHistory_activeList:
    'FILTERSEARCH_application_transactionDetail_etoeDetail_webActiveHistory_activeList',

  // Application > PA

  METRIC_application_wasView_wasDetail_metricChart:
    'METRIC_application_wasView_wasDetail_metricChart',
  METRIC_application_wasView_wasDetail_metricChart_python:
    'METRIC_application_wasView_wasDetail_metricChart_python',
  METRIC_application_wasView_wasDetail_metricChart_java:
    'METRIC_application_wasView_wasDetail_metricChart_java',
  METRIC_application_wasView_wasDetail_metricChart_dotnet:
    'METRIC_application_wasView_wasDetail_metricChart_dotnet',
  METRIC_application_wasView_wasDetail_metricChart_dotnet_framework:
    'METRIC_application_wasView_wasDetail_metricChart_dotnet_framework',
  METRIC_application_wasView_wasDetail_metricChart_nodejs:
    'METRIC_application_wasView_wasDetail_metricChart_nodejs',
  METRIC_application_webServerView_webServerDetail_nginx_metricChart:
    'METRIC_application_webServerView_webServerDetail_nginx_metricChart',
  METRIC_application_webServerView_webServerDetail_apache_metricChart:
    'METRIC_application_webServerView_webServerDetail_apache_metricChart',
  METRIC_application_webApplicationView_webApplicationDetail_metricChart:
    'METRIC_application_webApplicationView_webApplicationDetail_metricChart',
  METRIC_application_wasView_garbageCollectionDetail_metricChart:
    'METRIC_application_wasView_garbageCollectionDetail_metricChart',
  METRIC_application_pa_trendAnalysis_metricByTab:
    'METRIC_application_pa_trendAnalysis_metricByTab',

  TAB_application_wasDetail_selected: 'TAB_application_wasDetail_selected',
  TAB_application_webServerDetail_selected: 'TAB_application_webServerDetail_selected',
  TAB_application_webApplicationDetail_selected: 'TAB_application_webApplicationDetail_selected',
  OPTION_application_transactionDetail_etoe_summary_option:
    'OPTION_application_transactionDetail_etoe_summary_option',
  TAB_application_transactionDetail_etoeDetail_agent_selected:
    'TAB_application_transactionDetail_etoeDetail_agent_selected',
  TAB_application_transactionDetail_etoeDetail_database_selected:
    'TAB_application_transactionDetail_etoeDetail_database_selected',
  TAB_application_transactionDetail_etoeDetail_webserver_selected:
    'TAB_application_transactionDetail_etoeDetail_webserver_selected',

  TOGGLE_application_transactionDetail_etoe_summary_expanded:
    'TOGGLE_application_transactionDetail_etoe_summary_expanded',
  TOGGLE_application_wasDetail_agentInfo_expanded:
    'TOGGLE_application_wasDetail_agentInfo_expanded',
  TOGGLE_application_wasDetail_machineInfo_expanded:
    'TOGGLE_application_wasDetail_machineInfo_expanded',

  METRIC_application_wasView_wasDetail_metricChart_timePeriod:
    'METRIC_application_wasView_wasDetail_metricChart_timePeriod',
  METRIC_application_wasView_wasDetail_wasGarbageCollection_metricChart_timePeriod:
    'METRIC_application_wasView_wasDetail_wasGarbageCollection_metricChart_timePeriod',
  METRIC_application_webServerView_webServerDetail_nginx_metricChart_timePeriod:
    'METRIC_application_webServerView_webServerDetail_nginx_metricChart_timePeriod',
  METRIC_application_webServerView_webServerDetail_apache_metricChart_timePeriod:
    'METRIC_application_webServerView_webServerDetail_apache_metricChart_timePeriod',

  METRIC_application_webServerView_webServerDetail_webTransaction_etoeWebServerDetail_metricChart_timePeriod:
    'METRIC_application_webServerView_webServerDetail_webTransaction_etoeWebServerDetail_metricChart_timePeriod',

  METRIC_application_webApplicationView_webApplicationDetail_metricChart_timePeriod:
    'METRIC_application_webApplicationView_webApplicationDetail_metricChart_timePeriod',
  METRIC_application_transactionDetail_etoeDetail_metricChart_timePeriod:
    'METRIC_application_transactionDetail_etoeDetail_metricChart_timePeriod',
  METRIC_application_wasView_garbageCollectionDetail_metricChart_timePeriod:
    'METRIC_application_wasView_garbageCollectionDetail_metricChart_timePeriod',

  PA_application_target: 'PA_application_target',

  GRIDCOLUMNS_application_xviewPopup_list: 'GRIDCOLUMNS_application_xviewPopup_list',
  GRIDCOLUMNS_application_xviewPopup_stats: 'GRIDCOLUMNS_application_xviewPopup_stats',
  GRIDCOLUMNS_application_xviewPopup_excOtherTypes:
    'GRIDCOLUMNS_application_xviewPopup_excOtherTypes',
  GRIDCOLUMNS_application_xviewPopup_excAffectedTxns:
    'GRIDCOLUMNS_application_xviewPopup_excAffectedTxns',
  GRIDCOLUMNS_application_classViewWindow_methodProfile:
    'GRIDCOLUMNS_application_classViewWindow_methodProfile',
  GRIDCOLUMNS_application_classViewWindow_excHistory:
    'GRIDCOLUMNS_application_classViewWindow_excHistory',

  // Application > APM Overview (서비스 현황 모니터링)
  // 좌측 대상목록 선택 상태(그룹탭 + 부모/자식 선택) — 단일 키.
  SELECTION_application_overview_targetList: 'application_overview_target_selection',
  // X-View(트랜잭션 조회) y축 설정(지표/최대 ms) — 단일 키.
  METRIC_application_overview_xview: 'application_overview_xview',
  // Application Metric 차트별 지표 설정 — 슬롯키 접미사 결합: `${prefix}_${chartKey}` (metric1..metric8).
  METRIC_application_overview_metricSetting_prefix: 'application_overview',
  // 일일 통계 차트별 비교 날짜 설정 — 슬롯키 접미사 결합: `${prefix}.${chartKey}` (daily1/daily2).
  CONFIG_application_overview_dailyCompareDate_prefix: 'apm-overview.daily-compare-date',

  TOGGLE_application_webServerDetail_agent_expanded:
    'TOGGLE_application_webServerDetail_agent_expanded',
  TOGGLE_application_webServerDetail_performance_expanded:
    'TOGGLE_application_webServerDetail_performance_expanded',
  TOGGLE_application_webApplicationDetail_basicInfo_expanded:
    'TOGGLE_application_webApplicationDetail_basicInfo_expanded',
  TOGGLE_application_webApplicationDetail_performanceInfo_expanded:
    'TOGGLE_application_webApplicationDetail_performanceInfo_expanded',
  TOGGLE_application_sessionAnalysisDetail_info_expanded:
    'TOGGLE_application_sessionAnalysisDetail_info_expanded',
  TOGGLE_application_sessionAnalysisDetail_flow_expanded:
    'TOGGLE_application_sessionAnalysisDetail_flow_expanded',
  TOGGLE_application_sessionReplayDetail_info_expanded:
    'TOGGLE_application_sessionReplayDetail_info_expanded',
  TOGGLE_application_pageAnalysisDetail_analysis_expanded:
    'TOGGLE_application_pageAnalysisDetail_analysis_expanded',
  TOGGLE_application_pageAnalysisDetail_pageInfo_expanded:
    'TOGGLE_application_pageAnalysisDetail_pageInfo_expanded',
  TOGGLE_application_pageAnalysisDetail_userInfo_expanded:
    'TOGGLE_application_pageAnalysisDetail_userInfo_expanded',
  TOGGLE_application_pageAnalysisDetail_loadTimeline_expanded:
    'TOGGLE_application_pageAnalysisDetail_loadTimeline_expanded',
  TOGGLE_application_pageAnalysisDetail_loadTimelineDetail_expanded:
    'TOGGLE_application_pageAnalysisDetail_loadTimelineDetail_expanded',
  TOGGLE_application_browserErrorTrackingDetail_errorInfo_expanded:
    'TOGGLE_application_browserErrorTrackingDetail_errorInfo_expanded',
  TOGGLE_application_browserErrorTrackingDetail_browserInfo_expanded:
    'TOGGLE_application_browserErrorTrackingDetail_browserInfo_expanded',
  TOGGLE_application_userEventDetail_info_expanded:
    'TOGGLE_application_userEventDetail_info_expanded',
  TOGGLE_application_ajaxRequestHistoryDetail_info_expanded:
    'TOGGLE_application_ajaxRequestHistoryDetail_info_expanded',

  TOGGLE_application_wasDetail_environment_expanded:
    'TOGGLE_application_wasDetail_environment_expanded',
  TOGGLE_application_wasDetail_commandLine_expanded:
    'TOGGLE_application_wasDetail_commandLine_expanded',
  TOGGLE_application_wasDetail_gcOption_expanded: 'TOGGLE_application_wasDetail_gcOption_expanded',
  TOGGLE_application_wasDetail_gcAnalysis_expanded:
    'TOGGLE_application_wasDetail_gcAnalysis_expanded',
  TAB_application_ajaxRequestHistoryDetail_selected:
    'TAB_application_ajaxRequestHistoryDetail_selected',
  TAB_application_pageAnalysisDetail_selected: 'TAB_application_pageAnalysisDetail_selected',
};
